import { render } from "./Loginadmin.vue?vue&type=template&id=be5b4864"
import script from "./Loginadmin.vue?vue&type=script&lang=js"
export * from "./Loginadmin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__